import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Button from 'eventbrite_design_system/button/Button';

import './FilterButton.scss';

export const FilterButton = (props) => {
    return (
        <Button
            data-integration={`filter-section-button-${props.value}`}
            style="none"
            __containerClassName={classnames(
                'filter-section__button',
                `filter-section__button-${
                    props.isActive ? 'selected' : 'unselected'
                }`,
                {
                    'filter-section__button--mobile': props.isMobile,
                },
            )}
            onClick={props.onClick}
        >
            {props.children}
        </Button>
    );
};

FilterButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    value: PropTypes.string,
    isActive: PropTypes.bool,
};

export default FilterButton;
